import 'react-day-picker/style.css';
import './WrappedDayPicker.css';
import { DayPicker } from 'react-day-picker';
import { sv } from 'date-fns/locale';
import React from 'react';


interface IWRappedDayPicker{
  availableDates:Date[];
  selectedDate?: Date;
  selectedDateCallBack:(value:Date) => Promise<void>;
}
export const WrappedDayPicker = ({availableDates,selectedDate,selectedDateCallBack}:IWRappedDayPicker) => {    
    const HandleSelect = async(selected?:Date) => {
        if (!selected) return;

        const selectedTime = selected.toLocaleDateString('sv-SE');
        const isAvailable = availableDates.some(x => x.toLocaleDateString('sv-SE') === selectedTime);
        if (isAvailable) {
          await selectedDateCallBack(selected);
        }
    }
    
    return(
        <DayPicker locale={sv} /*modifiers={{booked:availableSlots}}*/ modifiers={{availableSlots:availableDates}}
            modifiersClassNames={{availableSlots:'rdp-day_available'}}
            mode='single'
            onSelect={HandleSelect}
            selected={selectedDate}
            
        />
    );
}
